import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import InputWrapper from '../common/InputWrapper';
import DatePicker from '../common/DatePicker';
import SelectComponent from '../common/Select';
import { DOCS_STATUSES_OPTIONS } from '../../config';
import { FilterWrapper } from './styled';
import Button from '../common/Button';
import moment from 'moment';
import { showModal } from '../../actions/modal';
import { fetchGetStatuses } from '../../actions/documents';

const FilterRow = ({ values, setFieldValue }) => {
  const dispatch = useDispatch();
  const [statuses, setStatuses] = useState(null);

  const isDateValid = (value) => {
    if (value && value !== 'Invalid date') {
      return value;
    } else {
      return null;
    }
  };

  const handleExportModal = () => {
    dispatch(showModal('DocumentExport', {}));
  };

  const findStatusLabel = DOCS_STATUSES_OPTIONS.find(
    (item) => item.value === values.statuses,
  )?.label;

  const getStatuses = async () => {
    const res = await dispatch(fetchGetStatuses());
    const newStatuses = Object.entries(res).map(([key, value]) => ({
      label: value,
      value: key,
    }));

    setStatuses(newStatuses);
  };

  useEffect(() => {
    getStatuses();
  }, []);

  return (
    <FilterWrapper>
      <div className="filters-row">
        <div className="form-group" style={{ marginRight: '10px' }}>
          <InputWrapper
            label="Поиск"
            placeholder="Номер поставки"
            id="number"
            value={values.id}
            onChange={(e) => setFieldValue('id', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Дата</label>
          <div className="dates-block">
            <DatePicker
              id="date_from"
              selected={
                isDateValid(values.date_from)
                  ? moment(values.date_from, 'YYYY-MM-DD').toDate()
                  : null
              }
              onChange={(date) =>
                setFieldValue('date_from', moment(date).format('YYYY-MM-DD[T]HH:mm:ss'))
              }
            />
            <div className="date-separator">-</div>
            <DatePicker
              id="date_to"
              selected={
                isDateValid(values.date_to) ? moment(values.date_to, 'YYYY-MM-DD').toDate() : null
              }
              maxDate={new Date()}
              onChange={(date) =>
                setFieldValue('date_to', moment(date).format('YYYY-MM-DD[T]HH:mm:ss'))
              }
            />
          </div>
        </div>
        <div className="col-sm-2 d-flex flex-row">
          <div className="form-group" style={{ width: '100%' }}>
            <div className="select-wrapper" style={{ minWidth: '200px' }}>
              <SelectComponent
                label="Статус"
                onChange={(value) => setFieldValue('statuses', value.value || null)}
                value={{ value: values.statuses, label: findStatusLabel || null }}
                options={statuses || []}
                styles={{ minWidth: '170px' }}
                isClearable={false}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-3 d-flex flex-row">
          <Button
            className="btn btn-light"
            type="button"
            text="Экспорт"
            style={{ maxHeight: '38px', marginTop: '10px', alignSelf: 'center' }}
            onClick={handleExportModal}
            icon="fe-arrow-down"
          />
        </div>
      </div>
    </FilterWrapper>
  );
};

export default FilterRow;
